import * as UserActions from '../../../../state/user/user.actions';
import Auth from '../../../../auth';

class AccountsSwitchingController {
  constructor($ngRedux, navService) {
    'ngInject';

    this.store = $ngRedux;
    this.navService = navService;
    this.userAccount = {};
    this.currentUserAccounts = null;
    this.searchQuery = '';
    this.userMemberAccountsCount = 0;
    this.filterAccounts = this.filterAccounts.bind(this);
    this.filterTrack = '';
  }

  $onInit() {
    this.unsubscribe = this.store.connect(this.mapStateToThis, UserActions)(this);
  }

  toggled(open) {
    if (open) {
      this.navService.hideSideNav();
    }
  }

  mapStateToThis(state) {
    const { user } = state;
    const { switchableAccounts, memberShipCount, currentAccount } = user;

    return {
      currentUserAccounts: switchableAccounts,
      userMembershipsCount: memberShipCount || 0,
      userAccount: currentAccount,
    };
  }

  filterAccounts(account) {
    if (!account) return;
    return accountNameContains(account, this.searchQuery);
  }

  gotoAccount(account) {
    if (account.id !== this.userAccount.id) {
      Auth.switchAccount(account.id);
    }
  }
}

export default {
  template: require('./accounts-switching.html'),
  restrict: 'E',
  controller: AccountsSwitchingController,
  controllerAs: 'vm',
};

//return true if the account name or one of it's sub account has the input text
export const accountNameContains = (account = {}, text) => {
  if (text) {
    text = text.toLowerCase();
  } else {
    return true;
  }

  const res =
    (account.name || '').toLowerCase().includes(text) ||
    (account.accounts || []).filter((sub) => (sub.name || '').toLowerCase().includes(text)).length >
      0;

  return res;
};
